export default __webpack_public_path__ + "static/media/Icons_Power_On Icon.623d7bdc.svg";